import { createFileRoute } from '@tanstack/react-router'
import { useOrganization } from '@/pages/organizations/detail'
import { useReports } from '@/pages/organizations/detail/reports'
import ChildrenOfTypeModulePage from '@/features/reports/components/pages/ChildrenOfTypeModulePage'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/modules/$moduleId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { childOrgTypeMachineName, moduleId } = Route.useParams()
  const { organization } = useOrganization()
  const { userCanViewAssessmentsChild, userCanViewResponsesChild } = useReports()

  return (
    <ChildrenOfTypeModulePage
      organization={organization}
      childOrgTypeMachineName={childOrgTypeMachineName}
      moduleId={Number(moduleId)}
      userCanViewAssessmentsChild={userCanViewAssessmentsChild}
      userCanViewResponsesChild={userCanViewResponsesChild}
    />
  )
}
